import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import PrivateRoutes from "./Routes/PrivateRoutes";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import ManageForecast from "./Pages/BottlerForecast/UploadForecast/ManageForecast";
import History from "./Pages/BottlerForecast/History/History";
import Login from "./Components/Login";
import ErrorPage from "./Pages/ErrorPage";
import Dashboard from "./Pages/BottlerForecast/Dashboard/Dashboard";
import Metrics from "./Pages/Metrics/Metrics";
import ProfitCenter from "./Pages/ProfitCenter/ProfitCenter";
import ManageUsers from "./Pages/ManageUsers/ManageUsers";
import OnboardBottler from "./Pages/OnboardBottler/OnboardBottler";
import { ThemeProvider } from "@mui/material";
import customTheme from "./Theme";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./auth/msalConfig";
import Authorize from "./Pages/Authorize";
import UserDetails from "./Pages/ManageUsers/UserDetail";
import ForecastPartnerConfiguration from "./Pages/OnboardBottler/ForecastPartnerConfiguration";
import PlantConfiguration from "./Pages/OnboardBottler/PlantConfiguration";
import PowerBIReports from "./Pages/BottlerForecast/PowerBIReports/PowerBIReport";
import TicketSummary from "./Pages/TicketSummary/ticketSummary";
import Reports from "./Pages/BottlerForecast/Reports/Reports";
import MaterialPlanning from "./Pages/BottlerForecast/MaterialPlaning/MaterialPlaning";
import AccessManagement from "./Pages/AccessManagement/AccessManagement";
import MFDashboard from "./Pages/MarketForecast/MFDashboard/MFDashboard";
import MFHistory from "./Pages/MarketForecast/MFHistory/MFHistory";
import MFManageForecast from "./Pages/MarketForecast/MFManageForecast/MFManageForecast";
import MFMetrics from "./Pages/MarketForecast/MFMetrics/MFMetrics";
import MFCustomConfiguration from "./Pages/MarketForecast/MFManageForecast/MFCustomConfiguration";
import FGDashboard from "./Pages/FGInventory/FGDashboard/FGDashboard";
import FGHistory from "./Pages/FGInventory/FGHistory/FGHistory";
import FGManageForecast from "./Pages/FGInventory/FGManageForecast/FGManageForecast";
import FGMetrics from "./Pages/FGInventory/FGMetrics/FGMetrics";
import BPMetrics from "./Pages/BusinessPlan/BPMetrics/BPMetrics";
import BPManageForecast from "./Pages/BusinessPlan/BPManageForecast/BPManageForecast";
import BPHistory from "./Pages/BusinessPlan/BPHistory/BPHistory";
import BPDashboard from "./Pages/BusinessPlan/BPDashboard/BPDashboard";
import DefaultDashboard from "./Pages/DefaultDashboard/DefaultDashboard";
import ReminderNotification from "./Pages/ReminderNotification/ReminderNotification";
import ActionDashboard from "./Pages/Reformulation/ActionDashboard/ActionDashboard";
import ActionHistory from "./Pages/Reformulation/ActionHistory/ActionHistory";
import PRDashboard from "./Pages/ProductionRequirement/PRDashboard/PRDashboard";
import PRHistory from "./Pages/ProductionRequirement/PRHistory/PRHistory";
import PRManageForecast from "./Pages/ProductionRequirement/PRManageForecast/PRManageForecast";
import PRMetrics from "./Pages/ProductionRequirement/PRMetrics/PRMetrics";
import FGTargetDays from "./Pages/FGInventory/FGTargetDays/FGTargetDays";
import CIDashboard from "./Pages/ConcentrateInventory/CIDashboard/CIDashboard";
import CIHistory from "./Pages/ConcentrateInventory/CIHistory/CIHistory";
import CIManageForecast from "./Pages/ConcentrateInventory/CIManageForecast/CIManageForecast";
import CIMetrics from "./Pages/ConcentrateInventory/CIMetrics/CIMetrics";
import CITargetDays from "./Pages/ConcentrateInventory/CITargetDays/CITargetDays";
import MFCountryConfiguration from "./Pages/OnboardBottler/MFCountryConfiguration";
import FGCountryConfiguration from "./Pages/OnboardBottler/FGCountryConfiguration";
import BPCountryConfiguration from "./Pages/OnboardBottler/BPCountryConfiguration";
import CICountryConfiguration from "./Pages/OnboardBottler/CICountryConfiguration";
import PRCountryConfiguration from "./Pages/OnboardBottler/PRCountryConfiguration";
import RealignmentMetrics from "./Pages/Reformulation/Metrics/RealignmentMetrics";
import PRCustomConfiguration from "./Pages/ProductionRequirement/PRManageForecast/PRCustomConfiguration";
import FGCustomConfiguration from "./Pages/FGInventory/FGManageForecast/FGCustomConfiguration";
import CICustomConfiguration from "./Pages/ConcentrateInventory/CIManageForecast/CICustomConfiguration";
import BPCustomConfiguration from "./Pages/BusinessPlan/BPManageForecast/BPCustomConfiguration";
import { ProfitCenterConfigurationPage } from "./Pages/Reformulation/ProfitCenterCinfiguration/ProfitCenterConfigurationPage";
import CountryConfiguration from "./Pages/OnboardBottler/CountryConfiguration";

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Provider store={store}>
        <App />
      </Provider>
    ),
    errorElement: <ErrorPage />,
    children: [
      // {
      //   path: "metrics",
      //   element: <PrivateRoutes />,
      //   children: [
      //     {
      //       path: "",
      //       element: <Metrics />,
      //     },
      //   ],
      // },
      {
        path: "dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <DefaultDashboard />,
          },
        ],
      },
      {
        path: "bf-dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <Dashboard />,
          },
        ],
      },
      {
        path: "bf-manage-forecast",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ManageForecast />,
          },
        ],
      },
      {
        path: "bf-history",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <History />,
          },
        ],
      },
      {
        path: "manage-user",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ManageUsers />,
          },
        ],
      },
      {
        path: "bottler-onboarding",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <OnboardBottler />,
          },
        ],
      },
      {
        path: "profit-center",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ProfitCenter />,
          },
        ],
      },
      {
        path: "user-details",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <UserDetails />,
          },
        ],
      },
      {
        path: "partner-config",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ForecastPartnerConfiguration />,
          },
        ],
      },
      {
        path: "/bf-country-config",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <CountryConfiguration />,
          },
        ],
      },
      {
        path: "/mf-country-config",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <MFCountryConfiguration />,
          },
        ],
      },
      {
        path: "/fg-country-config",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <FGCountryConfiguration />,
          },
        ],
      },
      {
        path: "/bp-country-config",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <BPCountryConfiguration />,
          },
        ],
      },
      {
        path: "/ci-country-config",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <CICountryConfiguration />,
          },
        ],
      },
      {
        path: "/pr-country-config",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PRCountryConfiguration />,
          },
        ],
      },
      {
        path: "plant-config",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PlantConfiguration />,
          },
        ],
      },
      {
        path: "bf-metrics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PowerBIReports />,
          },
        ],
      },
      {
        path: "access-Management",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AccessManagement />,
          },
        ],
      },
      {
        path: "/ticket-summary",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <TicketSummary />,
          },
        ],
      },
      {
        path: "report",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <Reports />,
          },
        ],
      },
      {
        path: "reminder-configuration",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ReminderNotification />,
          },
        ],
      },
      {
        path: "mapping-configuration",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <MaterialPlanning />,
          },
        ],
      },
      {
        path: "bmf-custom-configuration",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <MFCustomConfiguration />,
          },
        ],
      },
      {
        path: "pr-custom-configuration",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PRCustomConfiguration />,
          },
        ],
      },
      {
        path: "fgi-custom-configuration",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <FGCustomConfiguration />,
          },
        ],
      },
      {
        path: "ci-custom-configuration",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <CICustomConfiguration />,
          },
        ],
      },
      {
        path: "bp-custom-configuration",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <BPCustomConfiguration />,
          },
        ],
      },
      {
        path: "bmf-dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <MFDashboard />,
          },
        ],
      },
      {
        path: "bmf-history",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <MFHistory />,
          },
        ],
      },
      {
        path: "bmf-manage-forecast",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <MFManageForecast />,
          },
        ],
      },
      {
        path: "bmf-metrics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <MFMetrics />,
          },
        ],
      },
      {
        path: "fg-dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <FGDashboard />,
          },
        ],
      },
      {
        path: "fg-history",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <FGHistory />,
          },
        ],
      },
      {
        path: "fg-manage-forecast",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <FGManageForecast />,
          },
        ],
      },
      {
        path: "fg-metrics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <FGMetrics />,
          },
        ],
      },
      {
        path: "ci-TargetDaysOfSupply",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <CITargetDays />,
          },
        ],
      },
      {
        path: "pr-dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PRDashboard />,
          },
        ],
      },
      {
        path: "pr-history",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PRHistory />,
          },
        ],
      },
      {
        path: "manageProductionRequirement",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PRManageForecast />,
          },
        ],
      },
      {
        path: "pr-metrics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PRMetrics />,
          },
        ],
      },
      {
        path: "ci-dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <CIDashboard />,
          },
        ],
      },
      {
        path: "ci-history",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <CIHistory />,
          },
        ],
      },
      {
        path: "manageConcentrateInventory",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <CIManageForecast />,
          },
        ],
      },
      {
        path: "ci-metrics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <CIMetrics />,
          },
        ],
      },
      {
        path: "fg-TargetDaysOfSupply",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <FGTargetDays />,
          },
        ],
      },
      {
        path: "bp-dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <BPDashboard />,
          },
        ],
      },
      {
        path: "bp-history",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <BPHistory />,
          },
        ],
      },
      {
        path: "bp-manage-forecast",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <BPManageForecast />,
          },
        ],
      },
      {
        path: "bp-metrics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <BPMetrics />,
          },
        ],
      },
      {
        path: "actionDashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ActionDashboard />,
          },
        ],
      },
      {
        path: "actionHistory",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ActionHistory />,
          },
        ],
      },
      {
        path: "realign-metrics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <RealignmentMetrics />,
          },
        ],
      },
      {
        path: "pc-config",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ProfitCenterConfigurationPage />,
          },
        ],
      },
    ],
  },
  // {
  //   path: "/login",
  //   element: <Login />,
  // },
  {
    path: "/authorize",
    element: <Authorize />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={customTheme}>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </MsalProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

//--TODO Report web vitals  need  to utilize
reportWebVitals();
